import { GlobalSearchState } from '../../interfaces/global-search';
import {
  GlobalSearchReducerAction,
  GlobalSearchReducerActionType,
} from './interfaces';
import { filterGlobalSearchEntityData, filterStateData } from './globalSearchReducerUtil';

export function GlobalSearchReducer(
  state: GlobalSearchState,
  action: GlobalSearchReducerAction
): GlobalSearchState {
  switch (action.type) {
    case GlobalSearchReducerActionType.GET_ENTITY_DATA:
      return {
        ...state,
        items: {
          ...state.items,
          [action.entity]: {
            ...state.items[action.entity],
            loadingData: true
          }
        }
      };

    case GlobalSearchReducerActionType.UPDATE_ENTITY_DATA: {
      let newState = {
        ...state,
        items: {
          ...state.items,
          [action.entity]: {
            ...state.items[action.entity],
            ...action.data
          }
        }
      };

      newState = {
        ...newState,
        items: {
          ...newState.items,
          [action.entity]: {
            ...newState.items[action.entity],
            ...filterGlobalSearchEntityData(action.entity, newState),
            loadingData: false
          }
        }
      };

      return { ...newState };
    }

    case GlobalSearchReducerActionType.BULK_UPDATE:
      return {
        ...state,
        ...action.data
      };

    case GlobalSearchReducerActionType.FILTER_DATA: {
      const newState = {
        ...state,
        filters: {
          ...state.filters,
          ...action.data
        }
      };

      return {
        ...newState,
        items: {
          ...newState.items,
          ...filterStateData(newState),
        }
      };
    }

    default:
      return state;
  }
}
